import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs2001',
    ecrans: ['00-2']
});
